/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_BallroomInputs */

const en_val_ballroom = /** @type {(inputs: Val_BallroomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ballroom`)
};

const es_val_ballroom = /** @type {(inputs: Val_BallroomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salón de baile`)
};

const fr_val_ballroom = /** @type {(inputs: Val_BallroomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salle de bal`)
};

const de_val_ballroom = /** @type {(inputs: Val_BallroomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Festsaal`)
};

const ja_val_ballroom = /** @type {(inputs: Val_BallroomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ボールルーム (宴会場)`)
};

const zh_val_ballroom = /** @type {(inputs: Val_BallroomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`宴会厅`)
};

const ar_val_ballroom = /** @type {(inputs: Val_BallroomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قاعة حفلات`)
};

const id_val_ballroom = /** @type {(inputs: Val_BallroomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruang Dansa`)
};

const it_val_ballroom = /** @type {(inputs: Val_BallroomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sala da Ballo / Ricevimenti`)
};

const ru_val_ballroom = /** @type {(inputs: Val_BallroomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Банкетный зал`)
};

const pt_val_ballroom = /** @type {(inputs: Val_BallroomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salão de Festas`)
};

const ko_val_ballroom = /** @type {(inputs: Val_BallroomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연회장`)
};

/**
* | output |
* | --- |
* | "Ballroom" |
*
* @param {Val_BallroomInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_ballroom = /** @type {((inputs?: Val_BallroomInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_BallroomInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_ballroom(inputs)
	if (locale === "es") return es_val_ballroom(inputs)
	if (locale === "fr") return fr_val_ballroom(inputs)
	if (locale === "de") return de_val_ballroom(inputs)
	if (locale === "ja") return ja_val_ballroom(inputs)
	if (locale === "zh") return zh_val_ballroom(inputs)
	if (locale === "ar") return ar_val_ballroom(inputs)
	if (locale === "id") return id_val_ballroom(inputs)
	if (locale === "it") return it_val_ballroom(inputs)
	if (locale === "ru") return ru_val_ballroom(inputs)
	if (locale === "pt") return pt_val_ballroom(inputs)
	return ko_val_ballroom(inputs)
});